import {
  Pagination,
  TDeviceType,
  TMeasurementItem,
  TMeasurementList,
} from 'shared/types'
import { uniqueArray } from 'utils/uniqueArray'
import { api, getDevicesDetails } from '..'
import { usePaginatedQuery } from 'hooks/usePaginatedQuery'

export type TMeasurementListWithName = Pagination<
  TMeasurementItem & { name: string; type: TDeviceType }
>

export const getMeasurements = async (
  params?: Record<string, string>,
): Promise<TMeasurementListWithName> => {
  const { items, ...data } = await api
    .get<TMeasurementList>('/v1/measurements', {
      params,
    })
    .then(({ data }) => data)

  const deviceIds = uniqueArray(items.map(item => item.deviceId))
  const details = await getDevicesDetails(deviceIds)
  const newItems = items.map(item => {
    const device = details.get(item.deviceId)!
    return { ...item, name: device?.name, type: device?.type as TDeviceType }
  })

  return { ...data, items: newItems }
}

export const measurementListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getMeasurements(params),
  queryKey: ['measurements', params],
})

export const useGetMeasurements = (manualParams?: Record<string, string>) =>
  usePaginatedQuery(measurementListQuery, manualParams)
